import Alert from 'common-front/src/designSystem/components/alert';
import { Modal } from 'common-front/src/designSystem/components/modal/modal';
import { RATE_LIMIT_REQUESTS_NUMBER, RATE_LIMIT_WINDOW } from 'common/src/constants';
import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { styled } from 'common/src/designSystem/components/stitches';
import {
    useInterpolateWithComponents,
    useTranslate
} from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { Key } from '../../options/api/key';

const Dl = styled('dl', {
    margin: 0,
    code: {
        border: '1px solid color-mix(in srgb, $warning50, $warning400 60%)',
        backgroundColor: 'color-mix(in srgb, $warning50, $warning400 10%)',
        borderRadius: '$1',
        fontFamily: 'inherit',
        padding: '1px 3px'
    },
    dd: {
        display: 'list-item',
        listStyleType: 'disc'
    },
    'dd ~ dt': {
        marginTop: '$3'
    }
});

export const ApiExportModal = ({
    isOpen,
    onClose,
    link
}: Pick<React.ComponentProps<typeof Modal.Root>, 'isOpen' | 'onClose'> & { link: string }) => {
    const translate = useTranslate();
    const interpolateWithComponents = useInterpolateWithComponents();

    return (
        <Modal.Root isOpen={isOpen} onClose={onClose}>
            <Modal.Portal>
                <Modal.Header
                    icon="plug-circle-bolt"
                    subtitle={translate('exporter_votre_81734')}
                    onClose={onClose}
                >
                    {translate('export_de_votre_02014')}
                </Modal.Header>
                <Modal.Content>
                    <Flex direction="column" gap="4">
                        <Box css={{ marginBottom: '$5' }}>
                            <Alert.Root color="warning">
                                <Alert.Titled>
                                    <Alert.Title icon="circle-info">
                                        {translate('limites_des_exp_03687')}
                                    </Alert.Title>
                                    <Alert.Text>
                                        <Dl>
                                            <dt>{translate('limite_du_nombr_21498')}</dt>
                                            <dd>
                                                {[
                                                    ...interpolateWithComponents(
                                                        translate(
                                                            'au_del_de_1_41204',
                                                            RATE_LIMIT_REQUESTS_NUMBER,
                                                            RATE_LIMIT_WINDOW / 60000,
                                                            '{4}',
                                                            '{5}'
                                                        ),
                                                        <code>
                                                            Too many requests, please try again
                                                            later.
                                                        </code>
                                                    )
                                                ]}
                                            </dd>
                                            <dt>{translate('dans_google_she_53260')}</dt>
                                            <dd>
                                                {[
                                                    ...interpolateWithComponents(
                                                        translate(
                                                            'la_limite_de_1_47408',
                                                            RATE_LIMIT_REQUESTS_NUMBER,
                                                            RATE_LIMIT_WINDOW / 60000,
                                                            '{3}'
                                                        ),
                                                        <code>#N/A</code>
                                                    )
                                                ]}
                                            </dd>
                                            <dd>
                                                {[
                                                    ...interpolateWithComponents(
                                                        translate('_1_appelle_le_11127'),
                                                        <code>IMPORTDATA</code>
                                                    )
                                                ]}
                                            </dd>
                                            <dd>
                                                {[
                                                    ...interpolateWithComponents(
                                                        translate('_1_ne_fonction_68410'),
                                                        <code>IMPORTDATA</code>,
                                                        <code>#N/A</code>
                                                    )
                                                ]}
                                            </dd>
                                            <dd>
                                                {[
                                                    ...interpolateWithComponents(
                                                        translate('si_l_export_est_28345'),
                                                        <code>#N/A</code>
                                                    )
                                                ]}
                                            </dd>
                                        </Dl>
                                    </Alert.Text>
                                </Alert.Titled>
                            </Alert.Root>
                        </Box>
                        <Key
                            buttonColor="primary"
                            css={{
                                fontWeight: 500
                            }}
                            link={link}
                            title={translate('lien_d_api_pour_98778')}
                        />
                        <Key
                            buttonColor="primary"
                            css={{
                                fontWeight: 500
                            }}
                            link={`=IMPORTDATA("${link}")`}
                            title={translate('import_de_la_vu_17175')}
                        />
                    </Flex>
                </Modal.Content>
            </Modal.Portal>
        </Modal.Root>
    );
};
